import React, { useEffect } from "react";
import './App.css';
import Home from "./pages/home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Article from "./pages/article";
import TripDetails from "./pages/trips";

function App() {
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  }, []);

  const routes = createBrowserRouter([
    {
      path: "*",
      element: <Home />,
    },
    {
      path: "/articles/:id",
      element: <Article />,
    },
    {
      path: "/trips/:id",
      element: <TripDetails />,
    },
  ])

  return <RouterProvider router={routes} />;
}

export default App;
